import $ from 'jquery';

export default function() {
    $('.header__search, .custom-search__close').on('click', function (e) {
        e.preventDefault();
        if ($('.page-wrapper').hasClass('custom-search_opened')) {
            $('.page-wrapper').removeClass('custom-search_opened');
            $('html').removeClass('noscroll');
        } else {
            $('.page-wrapper').addClass('custom-search_opened');
            $('html').addClass('noscroll');
        }
    });
}